export default "__VITE_ASSET__BN8K1M1u__"